import get from 'lodash/get';

import Metric from '@module/metric';

// This method records an impression hit in Appsignal
// https://appsignal.com/wetransfer/sites/597eed5db504f501981926a9/metrics/Wallpapers
function sendAppsignalImpressionHit(wallpaper) {
  const providerName = wallpaper.providerName;
  Metric.send([
    'client_wallpaper_rotations',
    `wallpaper_${providerName.toLowerCase()}`,
  ]);
}

function sendSnowplowImpressionHit(wallpaper) {
  const payload = [
    // Snowplow bucket
    'trackAdImpression:ad_impressions',
    // impressionId
    get(wallpaper, 'creative.id', '0').toString(),
    // costModel - 'cpa', 'cpc', or 'cpm'
    'cpm',
    // cost
    0,
    // targetUrl
    get(wallpaper, 'creative.clickUrl', ''),
    // bannerId
    '',
    // zoneId
    get(wallpaper, 'position', '0').toString(),
    // advertiserId
    '',
    // campaignId
    '',
  ];

  // https://github.com/snowplow/snowplow/wiki/2-Specific-event-tracking-with-the-Javascript-tracker#36-ad-tracking-methods
  window.__snowplow__ && window.__snowplow__(...payload);
}

// Only send 5% of total impressions
const RATE_LIMIT = 5;

export const ImpressionMetrics = {
  sendWallpaperImpressionHits(wallpaper) {
    const random = Math.random() * 100;
    if (random > RATE_LIMIT) return;

    sendSnowplowImpressionHit(wallpaper);
    sendAppsignalImpressionHit(wallpaper);
  },
};
